import VersionNoteScreen from '@screens/VersionNote/VersionNoteScreen';

export default VersionNoteScreen;
